<template>
  <div id="app">
    <header-a></header-a>
    <el-card class="card_big" style="padding: 20px; box-sizing: border-box; min-height: 850px">
      <span class="basisInformation">公告管理</span>
       <el-divider></el-divider>
      <el-tabs v-model="activeName">
        <el-tab-pane label="公告管理" name="gonggao"></el-tab-pane>
      </el-tabs>
      <el-card class="quanbu" v-for="item in receiveDataList" :key="item.id">
        <div @click="clickDrawer(item.id)">
          <p style="margin-top: 10px; vertical-align: top">
            <el-tag type="success" size="mini">{{
              item.types == 0 ? '普通公告' : '质疑公告'
            }}</el-tag>
            <el-badge is-dot :hidden="item.readed">
              <span style="font-size: 17px; margin-left: 20px">{{
                item.title
              }}</span>
            </el-badge>
          </p>
          <p style="margin-top: 15px; font-size: 15px">{{ item.author }}</p>
          <p style="margin-top: 15px">{{ item.createTime }}</p>
        </div>
      </el-card>
      <!-- 分页 -->
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="currentChange"
        :hide-on-single-page="true"
        :total="totalCount"
      ></el-pagination>
      <p style="text-align: center" v-if="!receiveDataList.length">
        暂无公告信息
      </p>
    </el-card>
    <el-drawer
      :title="drawerList.title"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      
    >
      <div class="drawer" :style="{height:height+'px'}">
        <div style="margin-bottom:20px">
          <span>发布者：{{ drawerList.author }}</span>
          <span style="margin-left:20px">时间：{{ drawerList.createTime }}</span> 
        </div>
        <div class="textgonggao" v-html="drawerList.content"></div>
        <div>
          <a
            v-for="item in drawerList.attactList"
            :key="item.id"
            :href="item.link"
            :download="item.title"
            >{{ item.title }}</a
          >
        </div>
        <div>
          <img
            v-for="item in drawerList.imgList"
            :key="item.id"
            :src="item.link"
            alt=""
          />
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import headerA from '../../header/header'
import { receiveList, queryNotice } from '@/api/notice.js'
export default {
  components: {
    headerA,
  },
  data() {
    return {
      notice: {
        userId: localStorage.getItem('userId'),
        schoolId: localStorage.getItem('schoolIds'),
        roleType: localStorage.getItem('roleTypes'),
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      receiveDataList: [],
      drawerList: [], //公告详情
      dialogVisible: false,
      activeName:'gonggao',
      height:880,
    }
  },
  created() {
    this.receiveList()
  },
  mounted () {
    window.onresize = () => {
      this.height = document.documentElement.clientHeight - 80
    }
  },
  methods: {
    // 获取发布给自己的公告
    async receiveList() {
      const { data: res } = await receiveList({
        ...this.notice,
      })
      this.receiveDataList = res.data.dataList
      this.totalCount = res.data.totalCount
    },
    // 分页变化
    currentChange(e) {
      this.notice.curPage = e
      this.receiveList()
    },
    async clickDrawer(id) {
      this.dialogVisible = true
      const { data: res } = await queryNotice(id)
      this.drawerList = res.data
    },
    handleClose() {
      this.receiveList()
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
#app {
  background-color: #fafafa;
}
.basisInformation {
  font-size: 16px;
  font-weight: 700;
}
.card_big {
  margin: 18px auto;
  width: 1440px;
  min-height: 162px;
}
.el-divider {
  margin-top: 18px;
  margin-bottom: 8px;
}
.quanbu {
  cursor: pointer;
  height: 135px;
  width: 1360px;
  margin-bottom: 10px;
  position: relative;
}
.drawer {
  margin: 0 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
.drawer img {
  width: 100%;
}
.textgonggao p img {
  width: 100%;
}

.ql-align-center {
  width: 100%;
  display: inline-block;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/teacherNotice.vue